import { Component, OnInit } from '@angular/core';
import { faChevronRight, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { EventHistoryService } from 'src/app/services/event-history.service';
import moment from 'moment';
import { EventService } from 'src/app/services/event.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from '../../core/constant/common.constant';
import { HistoryDetailService } from 'src/app/services/history-detail.service';
import { Constants } from 'src/app/constants';
import { CommentRendererComponent } from 'src/app/core/grid-renderer/comment.grid-renderer';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-event-history',
  templateUrl: './event-history.component.html',
  styleUrls: ['./event-history.component.scss'],
  standalone: false // NOSONAR
})
export class EventHistoryComponent implements OnInit {
  menuVariable: boolean = false;
  faChevronRight = faChevronRight;
  faFileExcel = faFileExcel;
  gridOptions: any;
  name: any;
  openMenu() {
    this.menuVariable = !this.menuVariable;
  }
  gridApi: any;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: number = 10;
  icons: {};
  rowClassRules: any;
  shouldHide: any = true;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  historyRowData: any;
  connect: boolean = false;
  errorMessage: any;
  successMessage: any;
  eventId: string;
  eventData: any;
  eventType: any;
  plannedUnload: string;
  eventRegion: string;
  eventRoute: string;
  eventEta: string;
  eventStatus: string;
  reOpen: boolean;
  check: boolean = false;
  typeMap = new Map<number, string>();
  constructor(
    private readonly dialog: MatDialog, private readonly eventService: EventService,
    private readonly eventhistoryService: EventHistoryService,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    public readonly history: HistoryDetailService,
    public constants: Constants,
     private readonly route : ActivatedRoute,
  ) {
    this.defaultColDef = {
      suppressPaginationPanel: true,
      autoHeight: true,
    };
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',  // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
  }

  ngOnInit(): void {
    this.eventStatus = '';
    this.reOpen = false;
    this.eventId = '';
    this.eventType = '';
    this.plannedUnload = '';
    this.eventRegion = '';
    this.eventRoute = '';
    this.eventEta = '';

    if (localStorage.getItem('eventId')) {
      this.eventId = localStorage.getItem('eventId');
    }
    this.loadEventData();

    this.columnDefs = [
      {
        headerName: 'CHANGE TYPE', field: 'changeType',
        sortable: true, unSortIcon: true,
        minWidth: 70, maxWidth: 150,
        cellStyle: this.cellStyle
      },
      {
        headerName: 'EVENT TYPE', field: 'eventType',
        sortable: true, unSortIcon: true,
        minWidth: 70, maxWidth: 150,
      },
      {
        headerName: 'REGION', field: 'region',
        sortable: true, unSortIcon: true,
        minWidth: 70, maxWidth: 120,
      },
      {
        headerName: 'ROUTE', field: 'route',
        sortable: true, unSortIcon: true,
        minWidth: 70, maxWidth: 120,
      },
      {
        headerName: 'U/L',
        field: 'ul',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 150,
        valueFormatter: this.dateFormatter
      },
      {
        headerName: 'ETA',
        field: 'eta',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 150,
        valueFormatter: this.dateFormatter
      },
      {
        headerName: 'COMMENTS',
        field: 'comments',
        sortable: true,
        unSortIcon: true,
        filter: 'agTextColumnFilter',
        // minWidth: 320, maxWidth: 400,
        wrapText: true,
        autoHeight: true,
        cellStyle: { cursor: 'pointer' },
        cellRendererFramework: CommentRendererComponent,
        minWidth: 260,
        maxWidth: 350,
      },
      {
        headerName: 'LAST UPDATED',
        field: 'updatedBy',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 150,
        valueFormatter: this.dateFormatter
      },
      {
        headerName: 'LAST UPDATED BY',
        field: 'updatedTime',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 150,
      },
    ];
    const model = this.gridApi?.getFilterModel();
    this.gridApi?.setFilterModel(model);
  }

  loadEventData() {
    this.successMessage = null;
    this.errorMessage = null;
    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    let upn = fgaDetails?.user?.userPrincipalName;
    let roles = fgaDetails?.roles?.map(r => r.displayName);
    let lpCodes = this.getUserAttribute('additionalLpCode')  ?.split(',')  ?.map(code => code.trim()) || [];
      console.log(lpCodes);

    this.ngxUiLoaderService.start(CommonConstant.loader);
    const fromDashboard = this.route.snapshot.pathFromRoot.flatMap((val) => val.url.join('')).join('/').includes('dashboard');
    const data = {
      eventId: this.eventId,
      pageNo: fromDashboard ? '0' : '1',
      pageSize: '50'
    };

    this.eventService.getEventDetails(data, upn, roles, lpCodes).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.eventData = res;
        this.eventData.eventTypeList.forEach(value => {
          this.typeMap.set(value.eventTypeId, value.description);
        });
        this.eventType = this.findEventType(this.eventData.editEvent.eventTypeId, this.eventData.eventTypeList, 'eventTypeId');
        this.plannedUnload = this.etaFormat(this.eventData.editEvent.arrival);
        this.eventRegion = this.findRegionDescription(this.eventData.editEvent.region, this.eventData.regionList);
        this.eventRoute = this.eventData.editEvent.puRoute;
        this.eventEta = this.etaFormat(this.eventData.editEvent.eta);
        this.eventStatus = this.findEventType(this.eventData.editEvent.statusId, this.eventData.eventStatuses, 'statusId');
        if (this.eventStatus == 'Closed') {  // NOSONAR
          this.reOpen = false;
        } else {
          this.reOpen = true;
        }
        if (this.eventId) {
          this.check = true;
          this.apiCall();
        }
      },
      error: (error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        console.info(error)
      }
    })
  }

  getUserAttribute(key: string): any {

    let fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));

    return fgaDetails?.user?.applicationUserAttribute
      ?.flatMap(app => app.userAttributes)
      ?.find(attr => attr.key === key)
      ?.value;
  }

  findEventType(id, data, name) {
    for (let i = 0; i < data.length; i++) {

      if (data[i][name] == id) {  // NOSONAR
        return data[i].description;
      }
    }
    return "";
  }

  etaFormat(date) {
    if (date) {
      const value = moment(date).format('MM/DD/YYYY HH:mm')
      return value;
    } else {
      return "";
    }

  }

  findRegionDescription(regionCode, regionList) {

    for (let i = 0; i < regionList.length; i++) {
      if (regionList[i].itemCode == regionCode) {  // NOSONAR
        return regionList[i].itemDesc;
      }
    }
    return "";
  }

  apiCall() {
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.eventhistoryService.getEventHistory(this.eventId).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        const tableData = res;
        const changeMap = new Map<string, string>();
        changeMap.set('A', 'ADDED');
        changeMap.set('U', 'UPDATED');
        changeMap.set('D', 'DELETED');
        this.displayRowData = [];
        tableData?.forEach((row) => {
          row.data = JSON.parse(row.data);
          console.info(row);
          const data = row?.data ?? {};

          const obj = {
            changeType: changeMap.get(row?.changeType) ?? '',
            eventType: this.typeMap.get(data.event_type_id ?? data.eventTypeId) ?? '',
            region: data.region ?? '',
            route: data.puroute ?? data.puRoute ?? '',
            ul: data.arrival ?? '',
            eta: data.eta ?? '',
            comments: data.comments ?? '',
            updatedBy: data.last_updated ?? data.lastUpdated ?? '',
            updatedTime: data.last_updated_by ?? data.lastUpdatedBy ?? '',
          };

          this.displayRowData.push(obj);
        })
        this.displayRowData = [...this.displayRowData];
        this.rowCount = this.displayRowData.length;
      },

      error: (error) => {
        this.ngxUiLoaderService.stop();
        this.errorMessage = this.constants.APIErrorMessage;
        console.info(error);
      },
    });
  }

  dateFormatter(params) {
    return params.value ? moment.utc(params.value).format('MM/DD/YYYY HH:mm') : null;
  }
  cellStyle(params: any) {
    const fit_content = 'fit-content'
    if (params.data.changeType == 'A' || params.data.changeType == 'ADDED') { return { 'display': 'flex', 'justify-content': 'center', 'background-color': 'green', 'color': '#FFFFFF', 'border-radius': '25px', 'margin': '0 10px', 'max-width': fit_content, 'height': '20px' }; }  // NOSONAR
    else if (params.data.changeType == 'D' || params.data.changeType == 'DELETED') { return { 'display': 'flex', 'justify-content': 'center', 'background-color': '#D20000', 'color': '#FFFFFF', 'border-radius': '25px', 'margin': '0 10px', 'max-width': fit_content, 'font-size': '11px', 'height': '20px' }; }  // NOSONAR
    else { return { 'display': 'flex', 'justify-content': 'center', 'background-color': '#66ccff', 'color': '#FFFFFF', 'border-radius': '25px', 'margin': '0 10px', 'max-width': fit_content, 'font-size': '11px', 'height': '20px' }; }

  }
  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }
  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if (this.rowCount == 0 && Number(check) == 0) {  // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML = '0';
    }
  }
  onGridReady(params: any) {
    this.gridApi = params.api;

    this.gridApi.applyTransaction({ add: this.displayRowData });
  }

  goToNexpage() { this.gridApi.paginationGoToNextPage() }
  goToPreviousPage() { return this.gridApi.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage() }
  goToLastPage() { return this.gridApi.paginationGoToLastPage() }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else {
      this.currentPageBoolean = false;

    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText('#lbCurrentPage', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") {  // NOSONAR
      this.paginationPageSize = event.target.value;

    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }

}
